import { ContextMenu, ContextMenuContent, ContextMenuItem, ContextMenuLabel, ContextMenuSeparator, ContextMenuTrigger } from "@/components/ui/context-menu";

// items: [{ label, icon: Icon, onClick, danger, hidden, sep }]
export const RowMenu = ({ title, items, children }) => (
  <ContextMenu>
    <ContextMenuTrigger asChild>{children}</ContextMenuTrigger>
    <ContextMenuContent className="w-60" data-testid="row-context-menu">
      {title && <><ContextMenuLabel className="font-mono text-xs">{title}</ContextMenuLabel><ContextMenuSeparator /></>}
      {items.filter((i) => i && !i.hidden).map((i, idx) => i.sep ? <ContextMenuSeparator key={idx} /> : (
        <ContextMenuItem key={idx} className={i.danger ? "text-destructive focus:text-destructive" : ""} onSelect={() => i.onClick()} data-testid={`ctx-${i.testid || idx}`}>
          {i.icon && <i.icon size={14} className="mr-2" />}{i.label}
        </ContextMenuItem>
      ))}
    </ContextMenuContent>
  </ContextMenu>
);

export const copyText = (t) => navigator.clipboard.writeText(String(t));
